const Paths = {
  root: '/',
  user: {
    login: '/login',
    info: '/account/info',
    list: '/account/list',
    update: '/account/update',
    log: '/account/log',
    forgetPassword: '/forget-password',
    signup: '/signup',
    details: '/account/details',
  },
  appuser: {
    list: '/appuser/list',
  },
  appchannel: {
    list: '/appchannel/list',
  },
  pocaccount: {
    list: '/pocaccount/list',
    detail: '/pocaccount/detail',
    addchannels: '/pocaccount/addchannels',
    removechannels: '/pocaccount/removechannels',
    trial: '/pocaccount/trial'
  },
  pocchannel: {
    list: '/pocchannel/list',
    detail: '/pocchannel/detail',
    addmembers: '/pocchannel/addmembers',
    removemembers: '/pocchannel/removemembers',
    host: '/pocchannel/host',
    addhost: '/pocchannel/addhost',
    removehost: '/pocchannel/removehost',
  },
  summary: {
    summary: '/summary',
  },
  policy: {
    privacy: '/privacy',
    privacy2: '/privacy',
  },
  termsofuse: {
    termsofuse: '/termsofuse',
    termsofuse2: '/termsofuse',
  },
  notify: {
    log: '/notify',
  },
  invoice: {
    invoice: '/invoice',
  },
  coupon: {
    coupon: '/coupon',
  },
  servicecode: {
    servicecode: '/servicecode',
    assign: '/assigncode'
  },
  purchase: {
    purchasedetails: '/purchasedetails',
    purchaseAssignId: '/purchaseAssignId',
  },
  links: {
    links: '/links'
  },
  serverlogs: {
    serverlogs: '/serverlogs',
    getfiles: '/serverlogs/getfiles',
  },
  contract: {
    list: '/contract/list',
  },
  notifyfincode: {
    success: '/success',
    cancel: '/cancel',
    error: '/error',
  },
  fincode: {
    user: '/history/purchase/user',
    admin: '/history/purchase/admin',
    orderdatail: '/history/purchase/orderdetail'
  },
  device: {
    list: '/device/list',
    status: '/device/status',
    statusSF07: '/device/status/sf07',
    statusWBGT: '/device/status/wbgt',
    statusGPS: '/device/status/gps',
    statusSF03WT: '/device/status/sf03wt',
    statusSF03WT2: '/device/status/sf03wt2',
    statusXE1151: '/device/status/xe1151',
    status2: '/device/status2',
    activity: '/device/activity',
    detail: '/device/detail',
    activeAlert: '/alert/active',
    alertHistory: '/alert/history',
  },
  activity: '/activity',
  calllogs: {
    calllogs: '/calllogs',
    channellogs: '/channellogs'
  },
  channellogs: {
    channellogs: '/channellogs'
  },

};
export default Paths;
